import React from 'react';
import { Field, useFormikContext } from 'formik';
import { CustomSelectComponent } from 'motion-components';
import { useTranslation } from 'react-i18next';

/* ----------- Select Year ------------------ */
export const SelectContributionYear = ({
  required = false,
  name = 'year',
  title = 'Έτος',
  ...rest
}) => {
  const { t } = useTranslation();
  const yearOptions = () => {
    const firstYear = 2020;
    const newDate = new Date();
    const currentYear = newDate.getFullYear();
    const years = currentYear - firstYear;
    const options = [{ value: currentYear.toString(), label: currentYear.toString() }];

    let nextYear;
    for (let i = years - 1; i > 0; i--) {
      nextYear = firstYear + i;
      options.push({ value: nextYear.toString(), label: nextYear.toString() });
    }
    if (firstYear !== currentYear) {
      options.push({ value: firstYear.toString(), label: firstYear.toString() });
    }
    return options;
  };
  const { setFieldValue, values, errors, isValid } = useFormikContext();
  return (
    <>
      {/* {JSON.stringify(errors)} */}
      <Field
        {...rest}
        required={required}
        name={name}
        title={t(title)}
        component={CustomSelectComponent}
        options={yearOptions()}
      />
    </>
  );
};

